import Repository from "../../repository";

export default {
    ImportExcel: (payload) => Repository.post(`/api/ImportData/ImportExcel`, payload),
    NLImportExcel: (payload) => Repository.post(`/api/ImportData/NLImportExcel`, payload),
}
